import { FormControlLabel } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StySwitch } from 'ui/Switch/Switch';

type Props = {
    checked: boolean;
    disabled?: boolean;
    onChange: () => void;
    lastYear: number;
};

const ShowLastYearToggle = ({
    checked,
    disabled,
    onChange,
    lastYear,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <FormControlLabel
            sx={{ whiteSpace: 'nowrap' }}
            control={
                <StySwitch
                    checked={checked}
                    disabled={disabled}
                    onChange={onChange}
                />
            }
            label={t('humanResources.payState.showLastYear', {
                lastYear,
            })}
        />
    );
};

export default ShowLastYearToggle;
